import React from "react";
import { Link } from "react-router-dom";

const PLATFORM_LINKS = [
  ["Verify a Diamond", "/verify"],
  ["The Certificate", "/certificate"],
  ["Services", "/services"],
  ["Industry Login", "/login"],
];
const EXPLORE_LINKS = [
  ["For Industry", "/industry"],
  ["For Buyers & Retailers", "/buyers"],
  ["The Botswana Journey", "/journey"],
  ["Trust & Governance", "/trust"],
];
const CONNECT_LINKS = [
  ["Register Rough or Submit Polished", "/portal"],
  ["Contact & Participation", "/contact"],
];
const LEGAL_LINKS = [
  ["Certificate Methodology", "/legal/certificate-methodology"],
  ["Verification Limitations", "/legal/verification-limitations"],
  ["Participant Standards", "/legal/participant-standards"],
  ["Data Governance", "/legal/data-governance"],
  ["Privacy Policy", "/legal/privacy-policy"],
  ["Terms of Use", "/legal/terms-of-use"],
  ["Report a Certificate Concern", "/legal/report-concern"],
];


export default function Footer() {
  return (
    <footer className="relative border-t border-white/8 bg-[#040910] mt-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-5">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="" className="h-10 w-auto" />
            <div className="font-serif text-lg tracking-[0.18em]">BOTSWANA</div>
          </div>
          <p className="mt-5 text-sm text-bb-silver/60 leading-relaxed max-w-xs">
            Trusted digital identity, verification and market access infrastructure for Botswana origin exports, beginning with diamonds.
          </p>
        </div>

        <FooterCol title="Platform" links={PLATFORM_LINKS} />
        <FooterCol title="Explore" links={EXPLORE_LINKS} />
        <FooterCol title="Connect" links={CONNECT_LINKS} />
        <FooterCol title="Legal & Methodology" links={LEGAL_LINKS} />
      </div>

      <div className="border-t border-white/8">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-bb-silver/45">
          <p>
            LRG Botswana Brilliance is a Botswana-owned, SEZA-approved diamond services company operating independently in
            collaboration with licensed industry participants and approved technology providers.
          </p>
          <p className="whitespace-nowrap">© {new Date().getFullYear()} Botswana Brilliance</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="label-eyebrow mb-4">{title}</div>
      <ul className="space-y-3">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-bb-silver/70 hover:text-bb-gold transition-colors duration-300">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
